<template>
    <div>
        <Modal v-model="modalShow" title="登录" class-name="vertical-center-modal my-modal"
            @on-ok="ok" @on-cancel="cancel" :mask-closable="false" :loading="submitLoading"
            ok-text="登 录" cancel-text="暂不登录" width="400" :footer-hide="tabName == 's2'">
            <div slot="header" style="color:#f60;text-align:left">
                <Tabs v-model="tabName" @on-click="handelChangeTab">
                    <TabPane label="账号登录" name="s1"></TabPane>
                    <TabPane label="扫码登录" name="s2"></TabPane>
                </Tabs>
            </div>
            <!-- 账号登录 -->
            <template v-if="tabName == 's1'">
                <Form ref="formCustomRef" :model="formData" :rules="ruleCustom" :label-width="80">
                    <FormItem label="手机号" prop="phone">
                        <Input prefix="ios-contact" placeholder="输入手机号码" maxlength="11"
                            v-model="formData.phone" style="width: 255px"/>
                    </FormItem>
                    <FormItem label="验证码" prop="captcha">
                        <Input prefix="ios-unlock" placeholder="输入短信验证码" maxlength="6"
                            v-model="formData.captcha" style="width: 150px"/>
                        <Button @click="handleGetCode" :disabled="countdown > 0"
                            style="width: 102px" >{{ countdown > 0 ? `重 发(${countdown}s)` : '发送验证码' }}</Button>
                    </FormItem>
                </Form>
            </template>

            <!-- 扫码登录 -->
            <template v-if="tabName == 's2'">
                <div class="qrcode-login">
                    <!-- <div class="qrcode" ref="qrCodeUrl"></div> -->
                    <div class="qrcode" v-if="qrData.img">
                        <img :src="qrData.img" alt="扫码登录"
                            style="width:160px;height: 160px; display: block;"/>
                    </div>
                    <p>{{ qrData.text }}</p>
                </div>
            </template>
        </Modal>
    </div>
</template>

<script>
import {
    sendSmsCodeApi, //获取短信验证码
    loginForPhoneApi, //手机登录
    queryQrLoginStatusApi, //扫码登录结果查询
    getLoginQrCodeApi, //获取登录二维码
} from '@/api/apis/liveHome.js';
import QRCode from 'qrcodejs2'
import { mapState } from 'vuex'
export default {
    name: "LoginModal",
    data() {
        const validatePhone = (rule, value, callback) => {
            let reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
            if (!value) {
                return callback(new Error('手机号码不能为空'));
            } else if (!reg.test(value)) {
                return callback(new Error('手机号格式不正确'));
            } else {
                callback()
            }
        };
        return {
            modalShow: false,
            submitLoading: true,
            tabName: 's1',
            formData:{
                phone: '',
                captcha: '',
                modelType: 0,
                spreadPid: 0
            },
            ruleCustom:{
                phone: [{ required: true, validator: validatePhone, trigger: 'blur' }],
                captcha: [{ required: true, message: '请输入短信验证码', trigger: 'blur' }]
            },
            //验证码
            countdown: 0, // 倒计时的秒数
            timer: null, // 计时器
            countdownTime: 60, // 倒计时的总时长，如60秒
            //扫码登录
            timerQr: null, //轮询
            qrData: {
                img: '',
                scanImg: require('@/assets/img/live/scan_ok.png'),
                text: '使用焕新生活app扫一扫登录'
            },
            serverQrData: {}
        }
    },
    computed: {
        ...mapState(['isLogin', 'uuid']),
    },
    mounted() {
        this.$store.commit('setUUID', this.$store.state.uuid)  
    },
    methods: {
        //tab 点击
        handelChangeTab(val){
            let that = this
            // 清除定时器
            that.timer && clearInterval(this.timer)
            that.timerQr && clearTimeout(this.timerQr)
            this.qrData.img = ''
            this.qrData.text = '使用焕新生活app扫一扫登录'
            this.serverQrData = {}
            if(val == 's2'){
                //创建登录 二维码
                that.$nextTick(() => {
                    that.creatQrCode()
                    setTimeout(() => {
                        that.delayRequest() //扫码登录 轮询登录结果
                    }, 500);
                })
            }else{
                that.formData.phone = ''
                that.formData.captcha = ''
            }
        },
        //创建登录 二维码
        creatQrCode() {
            getLoginQrCodeApi({
                uuid: this.$store.state.uuid
            }).then(res => {
                this.serverQrData = res.data
                this.qrData.img = res.data.qrCode
            })
            // new QRCode(this.$refs.qrCodeUrl, {
            //     text: 'https://blog.csdn.net/weixin_42601136', // 转换为二维码的内容
            //     width: 160, height: 160,
            //     colorDark: '#000000',
            //     colorLight: '#ffffff',
            //     correctLevel: QRCode.CorrectLevel.H
            // });
        },
        //获取验证码
        handleGetCode(){
            let that = this
            if(!that.formData.phone){
                return that.$Message.error('请先输入手机号');
            }
            if (that.timer) return;
            //获取短信验证码
            sendSmsCodeApi({
                phone: that.formData.phone, strData: {
                    requestId: '', siteList: [{xsite: 0,ysite: 0}]
                }
            }).then(res => {
                that.countdown = that.countdownTime;
                that.timer = setInterval(() => {
                    if (that.countdown > 0) {
                        that.countdown -= 1;
                    } else {
                        clearInterval(that.timer);
                        that.timer = null;
                    }
                }, 1000);
                that.$Message.success('验证码已发送');
            })
        },
        //提交登录
        handleSubmit(name) {
            let that = this
            that.$refs[name].validate((valid) => {
                if (valid) {
                    //登录
                    loginForPhoneApi({
                        phone: that.formData.phone,
                        captcha: that.formData.captcha,
                        modelType: 0, spreadPid: 0
                    }).then(res => {
                        this.$store.commit('setLogin', { token: res.data.token, user: res.data })
                        // 清除定时器
                        that.timer && clearInterval(that.timer)
                        that.timerQr && clearTimeout(that.timerQr)
                        this.$Message.success('登录成功');
                        this.modalShow = false
                    }).catch(e => {
                        this.submitLoading = false;
                        setTimeout(() => {
                            this.submitLoading = true;
                        }, 50);
                    })
                } else {
                    this.submitLoading = false;
                    setTimeout(() => {
                        this.submitLoading = true;
                    }, 50);
                }
            })
        },
        ok () {
            this.handleSubmit('formCustomRef');
        },
        cancel () {
            // 清除定时器
            this.timer && clearInterval(this.timer)
            this.timerQr && clearTimeout(this.timerQr)
        },
        //扫码登录
        delayRequest() {
            clearTimeout(this.timerQr) // 清除定时器
            // 5s后请求
            this.timerQr = setTimeout(() => {
                this.requestLoginResult()
            }, 1000)
        },
        //扫码登录结果 轮询
        requestLoginResult(){
            let that = this
            queryQrLoginStatusApi({ qrToken: this.serverQrData.token }).then(res => {
                //二维码状态 unscan-未扫码 scanned-已扫码等待确认 success-登录成功
                if(res.data.qrStatus == 'scanned'){
                    this.qrData.img = this.qrData.scanImg
                    this.qrData.text = '扫码成功，请点击确认登录'
                }
                if(res.data.qrStatus == 'success'){
                    let data = res.data.loginResponse
                    this.$store.commit('setLogin', { token: data.token, user: data })
                    // 清除定时器
                    that.timer && clearInterval(that.timer)
                    that.timerQr && clearTimeout(that.timerQr)
                    this.$Message.success('登录成功');
                    this.modalShow = false
                }
                if(['scanned','unscan'].includes(res.data.qrStatus)){
                    this.delayRequest()
                }
            }).catch(e => {
                this.delayRequest()
            })
        }
    },
    beforeDestroy(){
        // 清除定时器
        this.timer && clearInterval(this.timer)
        this.timerQr && clearTimeout(this.timerQr)
    },
};
</script>

<style lang="scss">
.my-modal .ivu-modal-header {
    border-bottom: 0px solid #e8eaec;
    padding: 14px 16px 0 16px;
}
</style>
<style lang="scss" scoped>
.qrcode-login{
    text-align: center;
    .qrcode{
        width: 160px; height: 160px; margin: 0 auto;
    }
    p{
        font-size: 14px; color: #1f1e1e; margin-top:15px;
    }
}
</style>




// WEBPACK FOOTER //
// src/components/LoginModal.vue